import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { IBindingCallback2, IBindingAction } from '../../../../common/models/callback';
import EmailTextArea from '../../../../components/EmailTextArea';
import RegularButton from '../../../../components/RegularButton';
import IconButton from '../../../../components/IconButton';
import { ReactComponent as ArrowLeft } from '../../../../assets/icons/arrow-left.svg';
import { ReactComponent as PaperPlane } from '../../../../assets/icons/paper-plane.svg';
import { IAppState } from '../../../../common/models/store/IAppState';
import Checkbox from '../../../../components/Checkbox';
import styles from './styles.module.scss';

interface IPreviewEmailProps {
  messageTemplate: string;
  defaultSendSMS: boolean;
  onFinalize: IBindingAction;
  onSendEmail: IBindingCallback2<string, boolean>;
}

const PreviewEmail: FunctionComponent<IPreviewEmailProps> = ({
  defaultSendSMS,
  messageTemplate,
  onFinalize,
  onSendEmail
}) => {
  const [message, setMessage] = useState(messageTemplate);
  const [sendSMS, setSendSMS] = useState(defaultSendSMS);
  const disabled = !message.trim();

  const swipeHandler = useSwipeable({
    onSwipedLeft: () => {
      if (!disabled) onSendEmail(message, sendSMS);
    },
    onSwipedRight: onFinalize,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="cf-container container-wide justify-content-start cf-container-with-bttns">
      <div className="cf-title mb-2">
        <FormattedMessage
          id="candidateForm.email.title"
          defaultMessage="Customize email to new references"
        />
      </div>
      <div className="cf-subtitle mb-4">
        <FormattedMessage
          id="candidateForm.email.subtitle"
          defaultMessage={`If you’d like, you can add a personal touch and edit the email we’ll send to
          each of your references.`}
        />
      </div>
      <div className={styles.checkboxContainer}>
        <Checkbox
          checked={sendSMS}
          onChange={({ currentTarget }) => setSendSMS(currentTarget.checked)}
          label={{ id: 'candidateForm.email.sendSMS', defaultMessage: 'Send as SMS text message too?' }}
        />
      </div>
      <div className={styles.emailWrp}>
        <EmailTextArea
          customEmailHeader={(
            <FormattedMessage id="candidateForm.email.previewHeader" defaultMessage="<Reference first name,>" />
          )}
          message={message}
          onChange={setMessage}
        />
      </div>
      <div className="cf-buttons">
        <div className="mr-3">
          <IconButton
            size="lg"
            variant="bordered"
            icon={<ArrowLeft />}
            onClick={onFinalize}
          />
        </div>
        <RegularButton
          size="lg"
          disabled={disabled}
          onClick={() => onSendEmail(message, sendSMS)}
          textIntlId="candidateForm.email.sendEmail"
          defaultMessage="Send email"
          icon={<PaperPlane />}
          iconPosition="right"
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ referenceRequest: { messageTemplate }
}: IAppState) => ({ messageTemplate });

export default connect(mapStateToProps)(PreviewEmail);
